import Fab from "@mui/material/Fab";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import CallIcon from "@mui/icons-material/Call";

function Services() {

  const openWhatsApp = () => {
    window.open("https://wa.me/message/2IFIFHKHEM4ZK1", "_blank");
  };
  const makeCall = () => {
    window.location.href = "tel:+917794946360";
  };

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);





  return (

    <>
      <Fab
        color="primary"
        aria-label="call"
        onClick={makeCall}
        sx={{
          position: "fixed",
          bottom: 90,
          right: 20,
          zIndex: 1000,
        }}
      >
        <CallIcon />
      </Fab>
      <Fab
        color="success"
        aria-label="whatsapp"
        onClick={openWhatsApp}
        sx={{
          position: "fixed",
          bottom: 20,
          right: 20,
          zIndex: 1000,
        }}
      >
        <WhatsAppIcon />
      </Fab>
    </>
  );
}

export default Services;
